<template>
  <div
    :class="{
      hero: showTitle,
      'absolute top-0 inset-x-0 overflow-hidden': isInfoPage,
      'relative p-2': !isInfoPage,
    }"
    class="wrapper bg-grape-500 text-white z-20"
  >
    <div class="relative">
      <div v-if="!isInfoPage" class="absolute top-0 left-0 flex justify-between w-full z-10">
        <BackLink v-if="$route.path !== '/success' && $route.path !== '/'" />
        <DrIcon
          svg="delete-circle"
          height="24"
          width="24"
          class="mt-1 absolute right-0 cursor-pointer z-20"
          @click.native="closeWidget"
        />
      </div>
      <div class="hero-headers">
        <Transition :name="transitionName">
          <div :key="$route.meta.page">
            <div v-if="showTitle" class="relative pt-8 px-5 header-container">
              <h1 class="text-lg mb-0 hero-title">{{ title }}</h1>
              <p v-if="showTagline" class="text-sm mb-0 hero-tagline">
                {{ tagline }}
              </p>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <Transition name="slide-down">
      <PortalTarget class="z-50 relative h-full" name="hero-extra" />
    </Transition>
    <ProgressBar v-if="$route.meta.page < 15 && !isInfoPage" :show-text="textActive" />
    <CheckoutBar v-if="$route.meta.page >= 15 && !isInfoPage" :show-text="textActive" />
  </div>
</template>

<script>
import { format, addMonths } from 'date-fns'
import ProgressBar from './ProgressBar'
import CheckoutBar from './CheckoutBar'
import BackLink from './BackLink'

export default {
  name: 'Hero',
  components: {
    ProgressBar,
    CheckoutBar,
    BackLink,
  },
  props: {
    isInfoPage: {
      type: Boolean,
      default: false,
    },
    transitionTitles: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      textActive: true,
      hideTitle: false,
      transitionName: '',
    }
  },
  computed: {
    totalProducts () {
      let sum = 0
      this.$store.getters.getProducts.forEach((product) => {
        product.rates.forEach(() => (sum += 1))
      })
      return sum
    },
    title () {
      if (this.$route.path.endsWith('config')) {
        if (
          this.$route.params.id === 'CommercialCombined\\GeneralLiability' ||
          this.$route.params.id === 'AvivaCommercialCombined\\GeneralLiability'
        ) { return 'General liability' }
        if (
          this.$route.params.id === 'CommercialCombined\\EmployersLiability' ||
          this.$route.params.id === 'AvivaCommercialCombined\\EmployersLiability'
        ) { return 'Employers liability' }
        if (
          this.$route.params.id === 'CommercialCombined\\PublicLiability' ||
          this.$route.params.id === 'AvivaCommercialCombined\\PublicLiability'
        ) { return 'Public liability' }
        if (
          this.$route.params.id === 'CommercialCombined\\OfficeCover' ||
          this.$route.params.id === 'AvivaCommercialCombined\\OfficeCover'
        ) { return 'Contents and equipment' }
        if (this.$route.params.id === 'CommercialCombined\\AppearHere') return 'Pop up insurance'
        if (this.$route.params.id === 'ProfessionalIndemnity\\ProfessionalIndemnity') return 'Professional indemnity'
        if (this.$route.params.id === 'CyberSecurity\\CyberSecurity') return 'Cyber insurance (GDPR)'
        if (this.$route.params.id === 'LegalExpenses\\LegalExpenses') return 'Commercial legal protection'
        if (this.$route.params.id === 'ManagementLiability\\DirectorsAndOfficers') return 'Directors and officers (D&O)'
        if (this.$route.params.id === 'ManagementLiability\\EmploymentPracticesLiability') { return 'Employment practices liability' }
        if (this.$route.params.id === 'ManagementLiability\\Crime') return 'Crime'
        if (this.$route.params.id === 'HealthcareProfessional\\HealthcareProfessional') return 'Healthcare professional'
        if (this.$route.params.id === 'ProfessionalInsurance\\CyberSecurity') return 'Cyber insurance'
        if (this.$route.params.id === 'ProfessionalInsurance\\ProfessionalIndemnity') return 'Professional indemnity'
      }
      return this.$route.meta.title ? this.$route.meta.title : 'Welcome'
    },
    tagline () {
      if (this.$route.path.startsWith('/statements')) {
        return `You means ${
          this.$store.getters.getBusinessName
            ? this.$store.getters.getBusinessName
            : `${this.$store.getters.getFirstName} ${this.$store.getters.getLastName}`
        }`
      }
      if (this.$route.path === '/quote-confirmation') {
        const expiryDate = addMonths(this.$store.getters.getEffectiveDate, 1)
        const string = format(expiryDate, 'dd/MM/yyyy')

        return `It's valid until ${string}`
      }
      return this.$route.meta.tagline ? this.$route.meta.tagline : 'We need a bit of information to get started'
    },
    showTitle () {
      return !this.$route.meta.noTitle
    },
    showTagline () {
      return !this.$route.meta.noTagline
    },
  },
  watch: {
    $route (to, from) {
      if (!from.meta.page || !this.transitionTitles) {
        this.transitionName = ''
      } else {
        this.transitionName = to.meta.page > from.meta.page ? 'slide-next' : 'slide-prev'
      }
    },
  },
  updated () {
    setTimeout(() => {
      this.handleScroll()
    }, 500)
  },
  beforeDestroy () {
    const scrollView = document.getElementsByClassName('scroll-view')[0]
    if (scrollView) {
      scrollView.removeEventListener('scroll', this.handleScrollPosition)
    }
  },
  methods: {
    handleScroll () {
      setTimeout(() => {
        const scrollView = document.getElementsByClassName('scroll-view')[0]
        if (scrollView) {
          scrollView.addEventListener('scroll', this.handleScrollPosition)
        }
      }, 500)
    },
    handleScrollPosition () {
      const scrollView = document.getElementsByClassName('scroll-view')[0]
      if (scrollView.scrollTop > 15 && window.innerWidth >= 660) {
        this.textActive = false
      } else {
        this.textActive = true
      }
    },
    closeWidget () {
      window.parent.postMessage(
        {
          type: 'close-iframe',
          payload: {
            from: 'dr-widget',
            quoteActive: !!this.$store.getters.getReference,
            totalProducts: this.totalProducts,
            lastPage: this.$route.meta.page,
          },
        },
        '*'
      )
    },
  },
}
</script>

<style scoped>
.hero {
  height: 115px;
  margin-bottom: 45px;
}

.hero-headers {
  display: grid;
  grid-template: 'main';
  height: 100%;
}

.hero-headers > :first-child {
  z-index: 1; /* Prevent flickering on first frame when transition classes not added yet */
}

.hero-headers > :not(:first-child) {
  opacity: 0; /* Prevent flickering on first frame when transition classes not added yet */
}

.hero-headers > * {
  grid-area: main; /* Transition: make sections overlap on same cell */
}

@media (min-width: 660px) {
  .hero {
    position: absolute;
    left: 0;
    width: 100%;
    margin-bottom: 0;
  }
}

@media (max-width: 320px) {
  .header-container {
    @apply pt-5;
  }
}

.hero-title {
  line-height: 28px;
}

.hero-tagline {
  line-height: 20px;
}

.app-product-slide-0 {
  transform: translateX(0);
}

.app-product-slide-1 {
  transform: translateX(-15%);
}

.app-product-slide-2 {
  transform: translateX(-30%);
}
</style>
